import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

import { FULL_MENU } from "../../constants/menu";
import { useBoardItem } from "../../hooks/useBoardItem";
import {
  checkRoleAndPermissions,
  getPermissionMessage,
} from "../CheckRoleAndPermission";
import {
  BOARD_PERMISSION,
  NON_MEMBER_PERMISSIONS,
} from "../../constants/permission";
import { AuthContext } from "../../context/AuthProvider";

const MySidebar = ({ className }) => {
  const location = useLocation();
  const { boards } = useBoardItem();
  const { roleCode, isAdmin } = useContext(AuthContext);

  const activeMenu = FULL_MENU.find((c) => location.pathname.includes(c.to));

  const checkPermission = (e, menu) => {
    if (menu?.boardCode) {
      if (
        !checkRoleAndPermissions(
          roleCode,
          boards[menu.boardCode],
          BOARD_PERMISSION.ACCESS,
          NON_MEMBER_PERMISSIONS[menu.boardCode],
          isAdmin
        )
      ) {
        alert(getPermissionMessage(BOARD_PERMISSION.ACCESS));
        e.preventDefault();
      }
    }
  };

  return (
    <div className={className}>
      <div className="bg">
        <h2 style={{ lineHeight: 1.2 }}>{activeMenu?.title}</h2>
      </div>
      <ul>
        {activeMenu?.items?.map((item) => (
          <li
            className={location.pathname.includes(item.to) ? "on" : ""}
            key={item.id}
          >
            <Link onClick={(e) => checkPermission(e, item)} to={item.to}>
              {item.title}{" "}
              {location.pathname.includes(item.to) && (
                <FontAwesomeIcon icon={faChevronRight} size="sm" />
              )}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MySidebar;
